import React from 'react';
import _ from 'lodash';

import styles from './metricsStyles';

import DocumentList from 'buyside/components/presentation/DocumentList/documentList';

import { employerProfileDocumentUrl } from 'buyside/util/urlHelper';
import { formatDate } from 'buyside/util/dateHelper';

const Metrics = ({ fundProfile }) => {
  const { beta, sharpeRatio, turnoverRatio, metricsDocuments, metricsUpdatedAt } = fundProfile;
  const formatFloat = attr => _.isNumber(attr) && `${attr}`;
  const formatPercent = attr => _.isNumber(attr) && `${attr}%`;
  const items = [
    { label: 'Beta', value: formatFloat(beta) },
    { label: 'Sharpe Ratio', value: formatFloat(sharpeRatio) },
    { label: 'Turnover Ratio', value: formatPercent(turnoverRatio) }
  ].filter(item => item.value);
  return (
    <div>
      <ul className={styles.metricsList}>
        {items.map((item, idx) => (
          <li key={idx}>
            <h4>{item.label}</h4>
            <span>{item.value}</span>
          </li>
        ))}
      </ul>
      <div className={styles.metricsFooter}>
        <em>Metrics updated as of {formatDate(metricsUpdatedAt)}.</em>
      </div>
      {!!metricsDocuments.length && (
        <DocumentList
          title="Supporting Documents"
          documents={metricsDocuments}
          urlFn={employerProfileDocumentUrl}
        />
      )}
    </div>
  );
};

export default Metrics;
